export default function getTextColor(color: string | undefined): string {
  const rgbaMatches = color?.match(
    /rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([0-9.]+))?\)/g,
  );

  if (rgbaMatches && rgbaMatches.length > 0) {
    const luminances = rgbaMatches.map((rgba) => {
      const [, r, g, b, a = "1"] = rgba.match(
        /rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([0-9.]+))?\)/,
      )!;
      const red = parseInt(r, 10);
      const green = parseInt(g, 10);
      const blue = parseInt(b, 10);
      const alpha = parseFloat(a);

      const rNorm = red / 255;
      const gNorm = green / 255;
      const bNorm = blue / 255;

      const rLum =
        rNorm <= 0.03928
          ? rNorm / 12.92
          : Math.pow((rNorm + 0.055) / 1.055, 2.4);
      const gLum =
        gNorm <= 0.03928
          ? gNorm / 12.92
          : Math.pow((gNorm + 0.055) / 1.055, 2.4);
      const bLum =
        bNorm <= 0.03928
          ? bNorm / 12.92
          : Math.pow((bNorm + 0.055) / 1.055, 2.4);

      const luminance = 0.2126 * rLum + 0.7152 * gLum + 0.0722 * bLum;
      return luminance * alpha + (1 - alpha) * 1;
    });

    const avgLuminance =
      luminances.reduce((sum, l) => sum + l, 0) / luminances.length;

    return avgLuminance > 0.5 ? "#000000" : "#ffffff";
  }

  if (color && /^#([0-9a-f]{3,8})$/i.test(color)) {
    let hex = color.replace("#", "");
    if (hex.length === 3)
      hex = hex
        .split("")
        .map((c) => c + c)
        .join("");
    if (hex.length === 4)
      hex = hex
        .split("")
        .map((c) => c + c)
        .join("");
    if (hex.length === 6) hex = hex + "ff";

    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    const a = parseInt(hex.slice(6, 8), 16) / 255;

    // Use proper relative luminance
    const rNorm = r / 255;
    const gNorm = g / 255;
    const bNorm = b / 255;

    const rLum =
      rNorm <= 0.03928 ? rNorm / 12.92 : Math.pow((rNorm + 0.055) / 1.055, 2.4);
    const gLum =
      gNorm <= 0.03928 ? gNorm / 12.92 : Math.pow((gNorm + 0.055) / 1.055, 2.4);
    const bLum =
      bNorm <= 0.03928 ? bNorm / 12.92 : Math.pow((bNorm + 0.055) / 1.055, 2.4);

    const luminance = 0.2126 * rLum + 0.7152 * gLum + 0.0722 * bLum;
    const blended = luminance * a + (1 - a) * 1;

    return blended > 0.5 ? "#000000" : "#ffffff";
  }

  return "#ffffff";
}
